import styled from '@emotion/styled';
import { useNavigate } from 'react-router-dom';
import { Theme } from '@/styles/Theme';

import useCompanyInfo from '@/hooks/useCompanyInfo';
import { ROUTER } from '@/constants/constants';

import Text from '@/components/common/Text';
import DaysUntilNextPayment from '@/components/common/GNB/GnbProfile/DaysUntilNextPayment';

const GnbProfile = () => {
  const { data: companyInfo } = useCompanyInfo();
  const navigate = useNavigate();

  const subscriptionStatus = companyInfo?.data?.subscriptionStatus || 'free';
  const workerCount = companyInfo?.data?.workerCount || 0;

  const handleSubscriptionClick = () => {
    if (subscriptionStatus !== 'active') {
      navigate(ROUTER.PAYMENT);
    }
  };

  const getPlanText = () => {
    if (subscriptionStatus === 'active') {
      return '유료 플랜';
    }
    if (subscriptionStatus === 'expired') {
      return '구독 만료';
    }
    return '무료 플랜';
  };

  return (
    <ProfileContainer>
      {companyInfo && (
        <>
          <ImgWrapper src={companyInfo.data.image[0] ?? '/company.svg'} />
          <Text textAlign='center' fontSize='1rem' fontWeight={500}>
            {companyInfo.data.companyName}
          </Text>
          <SubscriptionInfo
            onClick={handleSubscriptionClick}
            clickable={subscriptionStatus !== 'active'}
          >
            <Text
              textAlign='center'
              fontSize='0.8125rem'
              fontWeight={400}
              color={Theme.colors.G_2}
            >
              {getPlanText()} · {workerCount}명
            </Text>
          </SubscriptionInfo>
          <DaysUntilNextPayment period={companyInfo.data.period} />
        </>
      )}
    </ProfileContainer>
  );
};

export default GnbProfile;

const ProfileContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  gap: 0.9375rem;
`;

const ImgWrapper = styled.img`
  width: 6.25rem;
  height: 6.25rem;

  padding: 0.3125rem;

  background-color: ${Theme.colors.WHITE};

  object-fit: contain;

  border-radius: 50%;
  /* box-shadow: 0rem 0rem 0.25rem 0rem rgba(0, 0, 0, 0.25); */
  /* border: 0.0625rem solid ${Theme.colors.G_2}; */
`;

interface SubscriptionInfoProps {
  clickable: boolean;
}

const SubscriptionInfo = styled.div<SubscriptionInfoProps>`
  cursor: ${({ clickable }) => (clickable ? 'pointer' : 'default')};
  transition: opacity 0.2s;

  &:hover {
    opacity: ${({ clickable }) => (clickable ? 0.7 : 1)};
  }
`;
